module.exports = __webpack_public_path__ + "static/image-fc68242e740a1fe3418abe416813f3ab.png";